module.exports = __webpack_public_path__ + "static/logo-wx-89f759cbfa30f5ac73dd5d4d55578088.png";